import BottomSheet from '@/shared/components/BottomSheet'
import { Caption } from '@/shared/components/typography'

type NoCompensationProps = {
  isOpen: boolean
  onClick: () => void
}

const NoCompensation = ({ isOpen, onClick }: NoCompensationProps) => {
  const bodyContent = (
    <div className="mb-10 mt-6 flex w-full flex-col gap-4 px-2">
      <div className="flex flex-col text-left">
        <Caption level="caption1" weight="regular">
          1. 조류 배설물, 송진, 황사먼지, 빗물 등으로 인한 외부 오염
        </Caption>
        <Caption level="caption1" weight="regular">
          2. 유리 금 손상처럼 과실 여부 판단이 어려운 경우
        </Caption>
        <Caption level="caption1" weight="regular">
          3. 휠(타이어 포함)이나 사이드미러 등, 외관 손상이지만 판단이 어려운 경우
        </Caption>
        <Caption level="caption1" weight="regular">
          4. 창문 모터나 엔진 시동 모터 등 소모품 관련 고장
        </Caption>
        <Caption level="caption1" weight="regular">
          5. 차량 내부에 보관된 현금이나 귀중품 분실
        </Caption>
        <Caption level="caption1" weight="regular">
          6. 미세한 긁힘, 찍힘, 눌림 자국 등 경미한 외관 손상
        </Caption>
      </div>
      <div className="flex flex-col text-left">
        <Caption level="caption1" weight="regular">
          - CCTV나 접수 시 촬영된 사진으로 확인이 어려운 경우에도 보상이 어렵습니다.
        </Caption>
        <Caption level="caption1" weight="regular">
          - 계절 변화로 인한 타이어 공기압 저하나 차량 방전 또한 보상 대상에 포함되지 않으니, 긴급 출동 서비스를
          이용해주시길 바랍니다.
        </Caption>
      </div>
    </div>
  )
  return (
    <BottomSheet
      isOpen={isOpen}
      title="주차대행 이용 시 보상불가 항목"
      className="title1"
      bodyContent={bodyContent}
      btnText="확인"
      onClick={onClick}
    />
  )
}

export default NoCompensation
